import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {EvsProductService} from '../../../../../common/services/EvsProduct.service';
import {ConfirmationService} from 'primeng/primeng';
import {ImageService} from '../../../../imageService';
import {AuthBusinessService} from '../../../../../common/services/AuthBusiness.service';

declare var $: any;

@Component({
  selector: 'app-cratingStampsList',
  templateUrl: './cratingStampsList.component.html',
  styles: [``],
  styleUrls: ['./cratingStampsList.component.css'],
  providers: [EvsProductService, ImageService, AuthBusinessService],
})
export class CratingStampsListComponent implements OnInit {
  @ViewChild('boxRetalStamps') boxRetalStamps;

  addContent = '';
  listContent = [];
  public user: any;
  formCratingBatch: FormGroup = this.fb.group({
    is_cratingStampsSingle: [true],
    is_cratingStampsList: [false],
    stampCode: ['', [Validators.required]],
    stampCodeList: this.fb.array([]),
  });

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private productService: EvsProductService,
    private confirmationService: ConfirmationService,
    private imageService: ImageService,
    private connectService: AuthBusinessService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
  }

  ngOnInit() {

  }
  // codeList

  codeList(): FormArray {
    return this.formCratingBatch.get('stampCodeList') as FormArray
  }

  newCodeList(): FormGroup {
    return this.fb.group({
      prefix: '',
      serialFirst: '',
      serialLast: '',
    })
  }

  addCodeList() {
    this.codeList().push(this.newCodeList());
  }

  removeCodeList(i: number) {
    this.codeList().removeAt(i);
  }

  // end codeList

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/share/cratingStampsList/cratingStampsList.component.ts